import React from 'react'
import _ from 'lodash/fp'

import { Link, withRouter } from 'react-router-dom'

import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogTitle from '@material-ui/core/DialogTitle'

import colors from '@fe/ui/colors'

const buildLink = (location, to) => {
  const searchParams = _.get('search', location)
  const toUrl = '/open/register' + searchParams
  // TODO encodeURIComponent(toUrl) and decode it in the router
  return `${to}?returnTo=${toUrl}`
}

const LoginDialog = props => (
  <Dialog open={props.open}>
    <DialogTitle>
      For at deltage i GLFR Open skal du have en GLFR bruger. Det er helt gratis og let at registrere sig!
    </DialogTitle>
    <DialogActions style={{ justifyContent: 'space-between' }}>
      <Button component={Link} to='/open' style={{ color: colors.error }}>
        Tilbage
      </Button>
      <div>
        <Button component={Link} to={buildLink(props.location, '/signup')} color='primary'>
          Opret bruger
        </Button>
        <Button component={Link} to={buildLink(props.location, '/login')} color='primary' autoFocus>
          Log ind
        </Button>
      </div>
    </DialogActions>
  </Dialog>
)

export default withRouter(LoginDialog)
